import React from "react";
import { cn } from "@sys42/utils";
import { Link } from "gatsby";

import * as styles from "./styles.module.css";

export function ShapeNavigation({
  className,
  active,
}: {
  className?: string;
  active?: "all" | "primitive" | "composite" | "community" | "my-shapes";
}) {
  return (
    <nav className={cn(styles.shapeNavigation, className)}>
      <Link
        className={cn(styles.link, active === "all" && styles.link_active)}
        to="/shapes"
      >
        All
      </Link>
      <Link
        className={cn(
          styles.link,
          active === "primitive" && styles.link_active,
        )}
        to="/shapes/primitive"
      >
        Primitive
      </Link>
      <Link
        className={cn(
          styles.link,
          active === "composite" && styles.link_active,
        )}
        to="/shapes/composite"
      >
        Composite
      </Link>
      <Link
        className={cn(
          styles.link,
          active === "community" && styles.link_active,
        )}
        to="/shapes/community"
      >
        Community
      </Link>
      <Link
        className={cn(
          styles.link,
          active === "my-shapes" && styles.link_active,
        )}
        to="/shapes/my-shapes"
      >
        My Shapes
      </Link>
    </nav>
  );
}
